<template>
  <section class="contact_section">
    <ParticalsComponent />
    <article class="contact_Content">
      <form @submit="submitAction">
        <input
          dir="auto"
          class="wow bounceIn"
          type="text"
          name="name"
          :placeholder="contactUsContent.formData.namePlaceHolder"
          v-model.trim="name"
        />
        <input
          dir="auto"
          class="wow bounceIn"
          type="text"
          name="userMobile"
          :placeholder="contactUsContent.formData.phonePlaceHolder"
          v-model.trim="phoneNumber"
        />
        <input
          dir="auto"
          class="wow bounceIn"
          type="email"
          name="email"
          :placeholder="contactUsContent.formData.emailPlaceHolder"
          v-model.trim="email"
        />
        <input
          dir="auto"
          class="wow bounceIn"
          type="text"
          name="title"
          :placeholder="contactUsContent.formData.messageTitlePlaceHolder"
          v-model.trim="messageTitle"
        />
        <textarea
          dir="auto"
          class="wow bounceIn"
          :placeholder="contactUsContent.formData.messagePlaceHolder"
          v-model.trim="messagePaylod"
        ></textarea>
        <vue-recaptcha
          :siteKey="siteKey"
          size="normal"
          theme="light"
          :tabindex="0"
          @verify="recaptchaVerified"
          @expire="recaptchaExpired"
          @fail="recaptchaFailed"
          ref="vueRecaptcha"
        >
        </vue-recaptcha>
        <button :disabled="!this.recaptchaVal">
          {{ contactUsContent.formData.buttonText }}
        </button>
      </form>
      <div class="desc_side wow fadeIn">
        <p>{{ contactUsContent.header }}</p>
        <img
          src="@/assets/contact_image.png"
          alt=""
          loading="lazy"
          draggable="false"
        />
        <p>
          <a :href="'mailto:' + contactData.email">
            <i class="far fa-envelope" />{{ contactData.email }}
          </a>
        </p>
        <p>
          <a :href="'tel:' + contactData.phoneNumber"
            ><i class="fas fa-phone-volume" />{{ contactData.phoneNumber }}</a
          >
        </p>
        <div class="social_accounts">
          <a :href="contactData.socialLinks.instagram" target="_blank">
            <i class="fab fa-instagram"></i
          ></a>
          <a :href="contactData.socialLinks.youtube" target="_blank">
            <i class="fab fa-youtube"></i
          ></a>
          <a :href="contactData.socialLinks.facebook" target="_blank">
            <i class="fab fa-facebook-f"></i
          ></a>
        </div>
      </div>
    </article>

    <WaveFooter />
  </section>
</template>

<script>
import ParticalsComponent from "@/components/ParticalsComponent";
import WaveFooter from "@/components/WavFooter";
import vueRecaptcha from "vue3-recaptcha2";
import { isEmpty, isValidEmail } from "@/util/methods";
import swal from "sweetalert";
import Form from "@/util/GoogleForm";
export default {
  name: "Contact",
  data() {
    return {
      name: "",
      phoneNumber: "",
      email: "",
      messageTitle: "",
      messagePaylod: "",
      recaptchaVal: false,
      siteKeyForTesting: process.env.VUE_APP_RECAPTCHA_TESTING,
      siteKey: process.env.VUE_APP_RECAPTCHA,
    };
  },

  components: {
    ParticalsComponent,
    vueRecaptcha,
    WaveFooter,
  },
  methods: {
    isEmpty,
    isValidEmail,
    submitAction(e) {
      e.preventDefault();
      const {
        recaptchaVal,
        name,
        phoneNumber,
        email,
        messageTitle,
        messagePaylod,
      } = this.$data;
      const { alertMessages } = this.contactUsContent;
      if (recaptchaVal) {
        if (isEmpty(name, phoneNumber, email, messageTitle, messagePaylod)) {
          swal({
            title: alertMessages.dataRequired.title,
            text: alertMessages.dataRequired.text,
            icon: "info",
            button: alertMessages.dataRequired.buttonText,
          });
          return;
        }
        if (!isValidEmail(email)) {
          swal({
            title: alertMessages.inValidEmail.title,
            text: alertMessages.inValidEmail.text,
            icon: "info",
            button: alertMessages.inValidEmail.buttonText,
          });
          return;
        }

        const requestParams = {
          name,
          phoneNumber,
          email,
          messageTitle,
          messagePaylod,
        };
        new Form("1FAIpQLSeOENC-jgJOxwAEAUinCBne5HYKmS_1cw1V6TIkwDbWCENi8g", {
          "entry.725449720": "name",
          "entry.816679511": "phoneNumber",
          "entry.869310301": "email",
          "entry.1443586578": "messageTitle",
          "entry.1722320114": "messagePaylod",
        }).submit(requestParams);
        swal({
          title: alertMessages.submitSuccess.title,
          text: alertMessages.submitSuccess.text,
          icon: "success",
          button: alertMessages.submitSuccess.buttonText,
        });

        this.resetInputsData();
      }
    },
    resetInputsData() {
      this.name = "";
      this.phoneNumber = "";
      this.email = "";
      this.messageTitle = "";
      this.messagePaylod = "";
    },
    recaptchaVerified() {
      this.recaptchaVal = true;
    },
    recaptchaExpired() {
      this.recaptchaVal = false;
    },
    recaptchaFailed() {
      this.recaptchaVal = false;
    },
  },
  computed: {
    contactUsContent() {
      const { lang } = this.$store.state;
      return this.$store.state[lang].contactUsContent;
    },
    contactData() {
      const { lang } = this.$store.state;
      return this.$store.state[lang].footerContent;
    },
  },
};
</script>

<style></style>
